import { IBaseModel, BaseModel } from '../base.model'
import {BMListingViewModel} from './bm-listing.viewmodel'

export interface IBMMeetingListingViewModel extends IBaseModel {
  master?: BMListingViewModel,
  creator: {
    firstname: string,
    lastname: string
  },
  date_start: string,
  date_end: string,
  date_next_meeting: string,
  is_archived: boolean,
  media_pdf: {
    link: string
  },
  reference: string,
  state: string
}
export class BMMeetingListingViewModel extends BaseModel implements IBMMeetingListingViewModel {
  master: BMListingViewModel
  creator: {
    firstname: string
    lastname: string
  }
  date_start: string
  date_end: string
  date_next_meeting: string
  is_archived: boolean
  media_pdf: {
    link: string
  }
  reference: string
  state: string
}



// WEBPACK FOOTER //
// ./src/models/bm/bm-meeting-listing.viewmodel.ts